import {
  useMutation,
  useQueryClient,
  UseMutationResult,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import type {
  EventWithRelationsDto,
  ResponseDto,
  DeleteEventDto,
} from "@mimber/schema"
import { eventsKeys } from "../events.utils"
import type { DeleteEventOptions } from "./useDeleteEvent.types"

export const useDeleteEvent = (
  eventUuid: string,
  options: DeleteEventOptions = {}
): UseMutationResult<
  ResponseDto<EventWithRelationsDto>,
  Error,
  DeleteEventDto
> => {
  guardAppUsage("mimber-organization", "useDeleteEvent")

  const { server } = useServerContext()
  const queryClient = useQueryClient()

  return useMutation({
    ...options,
    mutationFn: async (dto: DeleteEventDto = {}) => {
      const response = await server.post<ResponseDto<EventWithRelationsDto>>(
        `events/${eventUuid}/delete`,
        dto
      )
      return response.data
    },
    onSuccess: (response, variables, onMutateResult, context) => {
      queryClient.invalidateQueries({
        queryKey: eventsKeys.findAll(),
      })
      queryClient.removeQueries({
        queryKey: eventsKeys.findOne(eventUuid),
      })

      if (options?.onSuccess) {
        options.onSuccess(response, variables, onMutateResult, context)
      }
    },
  })
}
